import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import PlayLargeIcon from '../../../../assets/icons/PlayLargeIcon';
import { CardImageLabel } from '../../../../components/Card';
import { IKImage } from '../../../../components/IKImage';
import theme, { colorsPalette } from '../../../../theme';
import type { SendHitsEvent } from '../../const';
import { HITS_TYPES } from '../../const';
import { sendAlgoliaClickEvent } from '../../helpers';
import { getGeneralizedObject } from '../Hit/Hit';
import useStyles from './styles';

interface GridHitProps {
  hit?: any;
  sendEvent: SendHitsEvent;
}

const GridHit: FC<GridHitProps> = ({ hit, sendEvent }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const data = getGeneralizedObject(hit, undefined, true);

  const handleClickHit = () => {
    sendAlgoliaClickEvent(sendEvent, hit);
  };

  return (
    <Box className={classes.wrapper}>
      <Link className={classes.imageWrap} to={data?.link} onClick={handleClickHit}>
        <IKImage path={data?.preview_url} className={classes.image} />
        {data?.searchableType === HITS_TYPES.VIDEO && (
          <Box className={classes.playIconWrap}>
            <PlayLargeIcon className={classes.playIcon} color={colorsPalette.white} />
          </Box>
        )}
        {data?.searchableType === HITS_TYPES.PATHWAY && (
          <CardImageLabel
            wrapperClass={classes.label}
            name={t('page.discover.pathway')}
            bgColor={colorsPalette.pink}
            textColor={theme.palette.secondary.dark}
          />
        )}
        {data?.searchableType === HITS_TYPES.NEWS && (
          <CardImageLabel
            wrapperClass={classes.label}
            name={t('page.discover.news')}
            bgColor={colorsPalette.blueLight}
          />
        )}
      </Link>
      <Box className={classes.infoWrap}>
        <div className={classes.labelsWrapper}>
          {data?.categoriesArr && data?.categoriesArr.length > 0 && (
            <Box className={classes.categoriesWrapper}>{data.categoriesArr}</Box>
          )}
        </div>
        <Link to={data?.link} isReactLink={data?.isReactLink} onClick={handleClickHit}>
          <Typography variant="h2" className={classes.title}>
            {data?.title}
          </Typography>
        </Link>
        <Typography className={classes.description}>{data?.accompanyingText}</Typography>
      </Box>
    </Box>
  );
};

export default GridHit;
